import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { ROUTES } from "@/routes/path"
import { logout } from "@/lib/http/auth"

export default function JoinOrganization() {
  return (
    <div className="flex h-screen flex-col bg-gray-50 dark:bg-zinc-900 lg:flex-row">
      {/* Left column: features */}
      <div className="z-0 hidden w-1/2 flex-col bg-gradient-to-tr from-amber-300 via-lime-200 to-green-300 px-16 lg:flex">
        <div className="mt-10">
          <img src="/logo.svg" alt="Ledgerbeam" width={220} height={50} />
        </div>
        <ul className="mt-24 space-y-8 text-black">
          <li>
            <h5 className="border-l-2 border-black pl-4 text-lg font-semibold">Get started quickly</h5>
            <p className="mt-1 pl-4">Create or join an organization to start collaborating.</p>
          </li>
          <li>
            <h5 className="border-l-2 border-black pl-4 text-lg font-semibold">Support any business model</h5>
            <p className="mt-1 pl-4">
              Ecommerce, fintech, SaaS platforms, marketplaces, and more—all within a unified platform.
            </p>
          </li>
          <li>
            <h5 className="border-l-2 border-black pl-4 text-lg font-semibold">Join millions of businesses</h5>
            <p className="mt-1 pl-4">Ledgerbeam is trusted by ambitious startups and enterprises of every size.</p>
          </li>
        </ul>
      </div>

      <div className="mt-6 flex justify-center lg:hidden">
        <img src="/logo.svg" alt="Ledgerbeam" width={220} height={50} />
      </div>

      {/* Right column: selection card */}
      <div className="relative flex flex-1 justify-center p-4 md:items-center lg:py-10">
        <div className="relative z-10 w-full max-w-lg">
          <div className="rounded-xl bg-white p-8 shadow-xl dark:bg-zinc-800">
            <h1 className="mb-2 text-2xl font-semibold dark:text-zinc-100">Join your team</h1>
            <p className="mb-6 text-zinc-600 dark:text-zinc-400">Provide the invite token to join your organization.</p>
            <div className="mb-4 space-x-2">
              <Input label="Invite token" placeholder="Your invite token" className="flex-1" />
            </div>
            <Button className="w-full">Join team</Button>
          </div>
          <div className="-mt-4 w-full max-w-lg rounded-b-xl border-t bg-gray-50 px-8 py-5 text-center text-sm text-muted-foreground shadow-md shadow-gray-200 dark:border-zinc-700 dark:bg-zinc-800 dark:shadow-zinc-700">
            Don&apos;t have an invite token?{" "}
            <Link
              to={ROUTES.DASHBOARD.ORGANIZATION.CREATE}
              className="font-medium text-primary hover:underline dark:text-primary"
            >
              Create new organization
            </Link>{" "}
            or{" "}
            <span
              onClick={() => logout()}
              className="cursor-pointer font-medium text-primary hover:underline dark:text-primary"
            >
              use a different account
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
